import React from 'react';
import { connect } from 'react-redux'
import Page from './Page'
import PageHeaderOutline from '../layouts/PageHeaderOutline';
import TableSearchSection from '../wrappers/TableSearchSection';
import QueryPaginatePresentation from '../presentations/QueryPaginatePresentation';

import { PRODUCT_SEARCH, PRODUCT_TYPES } from '../../constants/inventory/Product'
import { dot, deepCopy, qset } from '../../lib/obj';
import { openPopup, closePopup } from '../../actions/PopupActions';

import './Page.css';
import './ProductsPage.css';

// The max number of produts to list
const PRODUCT_LIST_LIMIT = 50;
const LOCO_PRODUCT_SEARCH = deepCopy(PRODUCT_SEARCH);
qset(LOCO_PRODUCT_SEARCH.sort, { field: "createdAt", direction: "desc" }, { selected: true });

export const USER_VIEWS = [
  { value: "view", name: "View", layout: "Read only view" },
  { value: "edit", name: "Edit", desc: "Edit products view" }
];

class ProductsPage extends Page {

  onView(evt, history, item) {
    if (item) {
      history.push(`/products/${item.data.id}`);
    }
  }

  onShowProductLog(product) {
    this.props.openPopup({
      name: "ActionLog",
      props: {
        title: "Product Log",
        type: "actions",
        typeAlias: "product-actions",
        limit: 100,
        ignoreDelete: true,
        conditions: [{ subjectType: { eq: "product" } }, { subjectId: { eq: product.data.id } }]
      }
    });
  }

  onControlClick(conf, item) {
    if (conf.key === "log") {
      this.onShowProductLog(item);
    }
  }

  render() {
    // Get the docs
    return (
      <div className="Page ProductsPage">
        <PageHeaderOutline title={this.props.title || "Products"} top={this._backButton()} aside={<QueryPaginatePresentation type="products"/>}>
        </PageHeaderOutline>
        <TableSearchSection type="products" controllable="true"
          query={LOCO_PRODUCT_SEARCH}
          onAddItem={(f) => { f({ type: "part" }) }}
          controls={[{ title: "Show Log", key: "log", icon: ["far", "square-list"] }]}
          onControl={(conf, item) => { this.onControlClick(conf, item) }}
          layout={[
            { title: "", field: "image", type: "image", className: "Icon", saveField: "imageId" },
            { title: "ID", field: "id", type: "action", onClick: (e, h, i) => { this.onView(e, h, i) } },
            { title: "Type", field: "type", type: "dropdown", options: PRODUCT_TYPES, className: "Type" },
            { title: "Name", field: "name", type: "string", onClick: (e, h, i) => { this.onView(e, h, i) } },
            { title: "SKU", field: "sku", type: "string", className: "SKU", hype: "whisper" },
            { title: " ", field: "description", type: "text", className: "Description" },
          ]} />
      </div>
    );
  }
}

const mapState = (state, props) => {
  let list = dot(state.inventory, "products.list") || {};
  return {
    list: list,
    products: list.docs || []
  }
};

const mapDispatch = (dispatch) => {
  return {
    openPopup: (props) => dispatch(openPopup(props)),
    closePopup: () => dispatch(closePopup())
  }
};

export default connect(
  mapState,
  mapDispatch
)(ProductsPage)
